import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { DashboardV2ComponentDto, DashboardV2ComponentPlacementDto, DashboardV2Dto, ResultListDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpDashboardService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/dashboard', authService);
	}
	getMainDashboard(): Observable<DashboardV2Dto> {
		return super.doGet(true, "/main");
	}
	getDashboards(pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<DashboardV2Dto>> {
		return super.doGet(true, `/list?pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}
	getDashboard(id: number): Observable<DashboardV2Dto> {
		return super.doGet(true, `/${id}`);
	}
	getComponents(): Observable<DashboardV2ComponentDto[]> {
		return super.doGet(true, `/component/`);
	}
	createDashboard(payload: DashboardV2Dto): Observable<DashboardV2Dto> {
		return super.doPost(true, '/', payload);
	}
	editDashboard(id: number, payload: DashboardV2Dto): Observable<DashboardV2Dto> {
		return super.doPost(true, `/${id}`, payload);
	}
}
